/*@ngInject*/
const GridColumnModel = function ($http, $q, $rootScope, $window, localization, xmlUtil, preferenceModel,
                                  gridColumnConstant, appTypeConfigurationModel, submissionConstant) {

    let viewActiveOnlyCheckBoxChecked,
        columnPreference,
        selectedSubmissionFilterName,
        selectedActivityFilterName,
        selectedTaskFilterName,
        openFilterUri = {},
        savedFilterUri = {},
        savedSortType = {},
        savedSortKey = {},
        submissionParams = {},
        activityParams = {},
        taskParams = {};

    this.getSubmissionParams = function () {
        return submissionParams;
    };

    function updateSubmissionGridPageSizeLocalStorage(pageSize) {
        const submissionGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY);
        $window.localStorage.setItem(submissionGridPageSizeLocalStorageKey, pageSize);
    }

    this.setSubmissionParams = function (_submissionParams) {
        submissionParams = _submissionParams;

        updateSubmissionGridPageSizeLocalStorage(submissionParams.pageSize);
    };

    this.updateSubmissionParamByName = function (name, value) {
        submissionParams[name] = value;

        if (name === 'pageSize') {
            updateSubmissionGridPageSizeLocalStorage(value);
        }
    };

    this.getActivityParams = function () {
        return activityParams;
    };
    this.setActivityParams = function (_activityParams) {
        activityParams = _activityParams;
    };

    this.getTaskParams = function () {
        return taskParams;
    };

    function updateTaskGridPageSizeLocalStorage(pageSize) {
        const taskGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY);
        $window.localStorage.setItem(taskGridPageSizeLocalStorageKey, pageSize);
    }

    this.setTaskParams = function (_taskParams) {
        taskParams = _taskParams;

        updateTaskGridPageSizeLocalStorage(taskParams.pageSize);
    };

    this.updateTaskParamByName = function (name, value) {
        taskParams[name] = value;

        if (name === 'pageSize') {
            updateTaskGridPageSizeLocalStorage(value);
        }
    };

    this.updateActivityParamByName = function (name, value) {
        activityParams[name] = value;
    };

    this.setSelectedSubmissionFilterName = function (name) {
        selectedSubmissionFilterName = name;
    };

    this.setSelectedActivityFilterName = function (name) {
        selectedActivityFilterName = name;
    };

    this.setOpenFilterUri = function (namespace, filterUri) {
        openFilterUri[namespace] = filterUri;
    };

    this.getOpenFilterUri = function (namespace) {
        return openFilterUri[namespace];
    };

    this.setSavedFilterUri = function (namespace, filterUri) {
        savedFilterUri[namespace] = filterUri;
    };

    this.getSavedFilterUri = function (namespace) {
        return savedFilterUri[namespace];
    };

    this.setSavedSortType = function (namespace, type) {
        savedSortType[namespace] = type;
    };

    this.getSavedSortType = function (namespace) {
        return savedSortType[namespace];
    };

    this.setSavedSortKey = function (namespace, Key) {
        savedSortKey[namespace] = Key;
    };

    this.getSavedSortKey = function (namespace) {
        return savedSortKey[namespace];
    };

    this.setSelectedTaskFilterName = function (name) {
        selectedTaskFilterName = name;
    };

    this.setColumnPreference = function (preference) {
        columnPreference = preference;
    };

    this.getSelectedSubmissionFilterName = function () {
        return selectedSubmissionFilterName;
    };
    this.getSelectedActivityFilterName = function () {
        return selectedActivityFilterName;
    };
    this.getSelectedTaskFilterName = function () {
        return selectedTaskFilterName;
    };

    this.setViewActiveOnlyCheckBox = function (val) {
        viewActiveOnlyCheckBoxChecked = val;
    };

    this.isViewActiveOnlyCheckBoxChecked = function () {
        return viewActiveOnlyCheckBoxChecked;
    };

    this.getGridColumnXML = function (colChanged, userPrefName) {
        let xml = '<columns>',
            columns = this.getDropdownColumns(userPrefName);

        _.each(columns, function (item) {
            if (colChanged && item.name === colChanged.name) {
                item.visible = colChanged.visible;
            }
            xml += '<column visible="' + item.visible;
            xml += '" width="' + item.width + '"' + (item.accessor ? ' accessor="' + item.accessor + '"' : '')
                + (item.sort ? ' sort="' + item.sort + '"' : '')
                + (item.type ? ' type="' + item.type + '"' : '') + '>' + item.name + '</column>';
        });
        xml += '</columns>';
        return xml;
    };

    this.getColumnsXML = function (columns) {
        let xml = '<columns>';
        _.each(columns, function (item) {
            xml += '<column visible="' + item._visible;
            xml += '" width="' + item._width + '"' + (item._accessor ? ' accessor="' + item._accessor + '"' : '')
                + (item._sort ? ' sort="' + item._sort + '"' : '')
                + (item._type ? ' type="' + item._type + '"' : '') + '>' + item.__text + '</column>';
        });
        xml += '</columns>';
        return xml;
    };

    this.resetParams = function () {
        const submissionGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY);
        const submissionGridPageSize =
            $window.localStorage.getItem(submissionGridPageSizeLocalStorageKey) ||
            submissionConstant.DEFAULT_SUBMISSION_GRID_PAGE_SIZE;

        submissionParams = {
            key: 'status',
            startIndex: 0,
            pageSize: _.toInteger(submissionGridPageSize),
            sortType: 'asc',
            searchString: '',
            filterUri: ''
        };

        activityParams = {
            filterUri: '',
            startIndex: 0,
            pageSize: 25
        };

        const taskGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY);
        const taskGridPageSize =
            $window.localStorage.getItem(taskGridPageSizeLocalStorageKey) ||
            submissionConstant.DEFAULT_TASK_GRID_PAGE_SIZE;

        taskParams = {
            key: 'dueDate',
            startIndex: 0,
            pageSize: _.toInteger(taskGridPageSize),
            sortType: 'asc',
            searchString: '',
            filterUri: ''
        };
    };

    localization.getTranslations().then(function (translations) {
        this.reset = function () {
            viewActiveOnlyCheckBoxChecked = true;
            selectedSubmissionFilterName = _.get(translations, 'homePage.myAgencySubmissions');
            selectedTaskFilterName = _.get(translations, 'homePage.myTasks');
            columnPreference = null;
            selectedActivityFilterName = null;
            openFilterUri = {};
            savedFilterUri = {};
            savedSortType = {};
            savedSortKey = {};

            this.resetParams();

        };

        this.getWidgetConfig = function (userPrefName=null, name) {
            let config = null;
            if (userPrefName) {
                let userPreferences = preferenceModel.getUserPreferences();
                let widgetPref = userPreferences[userPrefName];
                if (widgetPref) {
                    let item = xmlUtil.parseStringWithoutFlattening(widgetPref);
                    config = item;
                    if (item.widget)
                      config = item.widget;
                    config = config[name];
                }
            }
            return config;
        }

        this.getDropdownColumns = function (userPrefName=null) {
            let columns = null;
            if (userPrefName) {
              columns = this.getWidgetConfig(userPrefName, 'columns');
            }
            if (!columns) {
              columns = preferenceModel.get(columnPreference, userPrefName==null);
            }
            if (!columns) {
                return;
            }

            let dropDownArray = [];
            _.each(columns.column, function (item) {
                let visibleProp = item._visible === 'true',
                    columnName = item.__text;
                dropDownArray.push({
                    displayName: item.__text === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE ? _.get(translations, 'homePage.grid.header.coverage') : columnName,
                    name: columnName,
                    accessor: item._accessor,
                    type: item._type,
                    sort: item._sort,
                    width: item._width,
                    visible: visibleProp,
                    disabled: columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED
                });
            });

            return dropDownArray;
        };

        this.getTaskDropdownColumns = function () {
            let columns = preferenceModel.get(columnPreference),
                removeColumns = ['Next Action', 'Overdue', 'Assigned to me'];
            if (!columns) {
                return;
            }

            _.remove(columns.column, function (item) {
                return _.indexOf(removeColumns, item.__text) !== -1;
            });

            let dropDownArray = [];
            _.each(columns.column, function (item) {
                let visibleProp = item._visible === 'true',
                    columnName = item.__text;

                dropDownArray.push({
                    displayName: item.__text === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE ? _.get(translations, 'homePage.grid.header.coverage') : columnName,
                    name: columnName,
                    width: item._width,
                    visible: visibleProp,
                    disabled: columnName === gridColumnConstant.TASK_GRID_TASK_SUMMARY
                });
            });

            return dropDownArray;
        };

        this.reset();
    }.bind(this));

    this.getSubmissionGridColumns = function (userPrefName=null) {
        let colViewModel = {},
            columns = null;
        if (userPrefName) {
            columns = this.getWidgetConfig(userPrefName, 'columns');
        }
        if (!columns) {
            columns = preferenceModel.get(columnPreference, false);
        }
        if (!columns) {
            return;
        }

        colViewModel.columns = [];
        _.each(columns.column, function (item) {
            let visibleProp = item._visible === 'true',
                columnName = item.__text;

            if (columnPreference === 'system.accountSubmissionsGridColumns' || columnPreference === 'system.accountOverviewSubmissionColumnsForAgent' || columnPreference === 'system.accountOverviewSubmissionColumnsForUnderwriter') {

                if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_INSURED) {
                    colViewModel.colInsuredName = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_STATUS) {
                    colViewModel.colStatus = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_STATUS_REASON) {
                    colViewModel.colStatusReason = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_EFFECTIVE) {
                    colViewModel.colEffectiveDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_EXPIRATION) {
                    colViewModel.colExpirationDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_PREMIUM) {
                    colViewModel.colPremium = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_NEXT_ACTION) {
                    colViewModel.colNextAction = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_ASSIGNED_TO) {
                    colViewModel.colAssignedTo = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_AGENCY) {
                    colViewModel.colAgency = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_RISK_STATE) {
                    colViewModel.colRiskState = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_TOTAL_LIMIT) {
                    colViewModel.colTotalLimit = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_OBLIGATION_NAME) {
                    colViewModel.colNameOfObligation = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_COVERAGE) {
                    colViewModel.colCoverage = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_SUBMISSION) {
                    colViewModel.colSubmissionNumber = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_RECEIVED_DATE) {
                    colViewModel.colReceivedDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_ACTION_DATE) {
                    colViewModel.colActionDate = visibleProp;
                }
            } else if (columnPreference === 'view.uw.homePageColumns') {
                if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED) {
                    colViewModel.colSubmissionNumber = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ACCOUNT_NAME) {
                    colViewModel.colAccountName = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_STATUS) {
                    colViewModel.colStatus = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_STATUS_REASON) {
                    colViewModel.colStatusReason = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_EFFECTIVE) {
                    colViewModel.colEffectiveDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_EXPIRATION) {
                    colViewModel.colExpirationDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PREMIUM) {
                    colViewModel.colPremium = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_NEXT_ACTION) {
                    colViewModel.colNextAction = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ACTION_DATE) {
                    colViewModel.colActionDate = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_AGENCY) {
                    colViewModel.colAgency = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_UNDERWRITER) {
                    colViewModel.colUnderwriter = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ASSIGNED_TO) {
                    colViewModel.colAssignedTo = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRODUCT) {
                    colViewModel.colCoverage = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRIORITY) {
                    colViewModel.colPriority = visibleProp;
                } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_RECEIVED_DATE) {
                    colViewModel.colReceivedDate = visibleProp;
                }
                colViewModel.columns.push(item);
            } else {
                colViewModel.columns.push(item);
            }
        });
        return colViewModel;
    };

    this.getTaskGridColumns = function () {
        let colViewModel = {},
            columns = preferenceModel.get(columnPreference);

        if (!columns) {
            return;
        }

        _.each(columns.column, function (item) {
            let visibleProp = item._visible === 'true',
                columnName = item.__text;

            if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED) {
                colViewModel.colInsuredName = visibleProp;
            } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ASSIGNED_TO) {
                colViewModel.colAssignedTo = visibleProp;
            } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRIORITY) {
                colViewModel.colPriority = visibleProp;
            } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE) {
                colViewModel.colCoverage = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_RESOLVED) {
                colViewModel.colResolved = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_DUE_DATE) {
                colViewModel.colDueDate = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_TASK_SUMMARY) {
                colViewModel.colTaskSummary = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_ASSIGNED_BY) {
                colViewModel.colAssignedBy = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_TASK_DETAILS) {
                colViewModel.colTaskDetails = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_EFFECTIVE_DATE) {
                colViewModel.colEffectiveDate = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_CREATED_DATE) {
                colViewModel.colCreatedDate = visibleProp;
            } else if (columnName === gridColumnConstant.TASK_GRID_RESOLVED_DATE) {
                colViewModel.colResolvedDate = visibleProp;
            }
        });

        return colViewModel;
    };

    this.getPoliciesGridColumns = function () {
        let colViewModel = {},
            columns = xmlUtil.parseString(preferenceModel.get(columnPreference));

        colViewModel.columns = columns.column;

        if (!columns) {
            return;
        }

        _.each(columns.column, function (item) {
            let visibleProp = item._visible === 'true';
            colViewModel[item.__text] = item._visible;
        });

        return colViewModel;
    };

    this.getSubmissionTransactionGridColumns = function () {
        let colViewModel = {},
            columns = xmlUtil.parseString(preferenceModel.get(columnPreference));

        colViewModel.columns = columns.column;

        if (!columns) {
            return;
        }

        _.each(columns.column, function (item) {
            let visibleProp = item._visible === 'true';
            colViewModel[item.__text] = item._visible;
        });
        return colViewModel;
    };

    this.resetParams();
};

angular.module('umCore')
    .service('gridColumnModel', GridColumnModel);
